import {useEffect} from 'react';

export function useEditorPrefetchDefaultMobileModules(): void {
  useEffect((): void => {
    void prefetchDefaultModules();
  }, []);

  const prefetchDefaultModules = async (): Promise<void> => {
    await import(/* webpackPrefetch: true */ '@Panels/poster-add-items-panel');
    await import(/* webpackPrefetch: true */ '@Panels/resize-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-background-type-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-title-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editing-folds-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-grid-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-bleed-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-more-options-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-nav-more-options-panel');

    // common options
    await import(/* webpackPrefetch: true */ '@Panels/poster-editing-item-position-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-opacity-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editing-item-flip-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-hyperlink-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editor-item-stretch-panel');
    await import(/* webpackPrefetch: true */ '@Panels/poster-editing-item-symmetry-panel');
    await import(/* webpackPrefetch: true */ '@Panels/edit-audio-item-panel');
    await import(/* webpackPrefetch: true */ '@Panels/duration-dropdown');
  };
}
